import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './../styles/style.css'

const resultStyle = {
  padding: '10px 7px',
  maxWidth: 350,
  whiteSpace: 'normal',
  lineHeight: '1.5em',
}

// Location Search Result
export default class LocationSearchResult extends Component {
  constructor () {
    super()

    this.onSelect = this.onSelect.bind(this)
  }

  onSelect () {
    this.props.onSelectResult(this.props.result)
  }

  render () {
    return (
      <div
        data-test='LocationSearchResult'
        style={resultStyle}
        className='loc_item'
        onClick={this.onSelect}
      >
        {this.props.result.display_name}
      </div>
    )
  }
}

LocationSearchResult.propTypes = {
  result: PropTypes.shape({
    display_name: PropTypes.string.isRequired,
  }).isRequired,
  onSelectResult: PropTypes.func.isRequired,
}
